import ServerDirections from '@/config/server-directions'
import { ProfileCategory } from '@/entities/ProfileCategory'

import { RequestService } from '@/services/request.service'
const requestService = new RequestService()

export class ProfileCategoryRequests {
  list () {
    const route = ServerDirections.PROFILE_CATEGORIES
    const method = 'get'
    function map (data) {
      return data.map(item => new ProfileCategory(item))
    }
    return requestService.makePromise(route, method, {}, map)
  }
}
